module.exports = __webpack_public_path__ + "static/img/5.686b8a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/2/5.png
// module id = rB2k
// module chunks = 0